import React, { useEffect } from "react";
import AOS from "aos";
import "./Footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    AOS.init({ duration: 800, offset: 100 });
  }, []);

  return (
    <>
      {/* CTA Section */}
      <section className="footer-cta">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-6" data-aos="fade-up">
              <h2 className="cta-title">
                Ready to Transform Your Business?{" "}
                <span className="gradient-text">Let's Talk</span>
              </h2>
              <p className="cta-subtitle">
                We specialize in enterprise solutions, custom software, and
                cloud infrastructure. Share your vision, and we'll build your
                future.
              </p>
              <div className="contact-info mt-4">
                <div className="info-item mb-3">
                  <span className="info-icon">✉️</span>
                  <a href="mailto:info@mzrsoftware.com">info@mzrsoftware.com</a>
                </div>
                <div className="info-item mb-3">
                  <span className="info-icon">📱</span>
                  <span>+92 335 120 6586</span>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="cta-box">
                <h3 className="cta-box-title">Quick Contact</h3>
                <p className="cta-box-text">
                  Message us on WhatsApp for instant response or leave your
                  details for a callback.
                </p>
                <div className="cta-buttons">
                  <a
                    href="https://wa.me/923351206586?text=Hi%20MZR%20Software%20Team!%20I'm%20interested%20in%20discussing%20a%20project.%20%0A%E2%80%A2%20Project%20Type:%20%0A%E2%80%A2%20Timeline:%20%0A%E2%80%A2%20Budget:%20"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-cta btn-whatsapp"
                  >
                    💬 WhatsApp Us
                  </a>
                  <a
                    href="mailto:info@mzrsoftware.com"
                    className="btn-cta btn-email"
                  >
                    📧 Send Email
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer-main">
        <div className="container">
          <div className="row g-4 mb-5">
            {/* Company Info */}
            <div className="col-lg-3 col-md-6" data-aos="fade-up">
              <div className="footer-brand">
                <img
                  src="/img/logo_mzrsoftware.png"
                  alt="MZR Software"
                  className="brand-logo-img"
                />
              </div>
              <p className="footer-desc">
                Enterprise-grade software solutions for 13+ years. Custom
                development, cloud architecture, and digital transformation.
              </p>
            </div>

            {/* Quick Links */}
            <div
              className="col-lg-3 col-md-6"
              data-aos="fade-up"
              data-aos-delay="50"
            >
              <h5 className="footer-heading">Quick Links</h5>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/service">Services</Link>
                </li>
                <li>
                  <Link to="/portfolio">Portfolio</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div
              className="col-lg-3 col-md-6"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h5 className="footer-heading">Services</h5>
              <ul className="footer-links">
                <li>
                  <Link to="/custom-software">Custom Software</Link>
                </li>
                <li>
                  <Link to="/pos-system">POS & ERP Systems</Link>
                </li>
                <li>
                  <Link to="/cloud-devops">Cloud & DevOps</Link>
                </li>
                <li>
                  <Link to="/mobile-development">Mobile Development</Link>
                </li>
                <li>
                  <Link to="/ai-solutions">AI Solutions</Link>
                </li>
              </ul>
            </div>

            {/* Connect */}
            <div
              className="col-lg-3 col-md-6"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              <h5 className="footer-heading">Connect With Us</h5>
              <div className="social-links">
                <a
                  href="https://www.linkedin.com/company/mzr-software"
                  className="social-link"
                  title="LinkedIn"
                >
                  in
                </a>
                <a
                  href="https://www.facebook.com/mzrsoftware"
                  className="social-link"
                  title="Facebook"
                >
                  fb
                </a>
              </div>
              <p className="footer-contact mt-3">
                <strong>Email:</strong>
                <br />
                info@mzrsoftware.com
              </p>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="row align-items-center">
              <div className="col-md-6">
                <p className="footer-copyright">
                  © {currentYear} <span>MZR Software</span>. All rights
                  reserved.
                </p>
              </div>
              <div className="col-md-6 text-end">
                <p className="footer-legal">
                  <Link to="/Privacy/privacy">Privacy Policy</Link> •{" "}
                  <Link to="/Term/terms">Terms & Conditions</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
